/**
 * @param phoneNumber {string}
 * @return {string}
 */
module.exports = function validatePhoneNumber(phoneNumber) {
    if (/^\+\d{11}$/.test(phoneNumber)) {
        return "";
    }

    return "Please enter a valid phone number";
}
